<template>
  <span
    v-if="!blockLogoImage"
    class="block"
    style="font-family: var(--f-primary)"
    :style="getPositionStyle"
    :class="getPositionClass"
  >
    {{ blockSymbol }}
  </span>
  <img
    v-if="blockLogoImage"
    :src="blockLogoImage"
    class="block block-image"
    :style="getPositionStyle"
    :class="getPositionClass + ' ' + imageClass"
  />
</template>

<script lang="ts">
export default defineNuxtComponent({
  name: 'BlockSymbol',

  props: {
    positionText: {
      type: String,
      default: 'right_bottom',
    },
    blockColor: {
      type: String,
      default: 'primary',
    },
    blockSymbol: {
      type: String,
    },
    blockOpacity: {
      type: Number,
      default: 1,
    },
    blockLogoImage: {
      type: String,
      default: '',
    },
    imageClass: {
      type: String,
      default: '',
    },
    companyKey: {
      type: String,
      default: '',
    },
  },

   computed: {
    getPositionClass(): string {
      // @ts-ignore - props are correctly defined above
      const position = this.positionText || 'right-bottom';
      if (this.companyKey === 'kineticestateagents') {
        switch (position) {
          case 'left_bottom':
            return '-tw-bottom-8 -tw-left-[5rem] tw-rotate-[155deg]';
          case 'right_bottom':
            return '-tw-bottom-8 -tw-right-[0rem] tw-rotate-[5deg] tw-w-[80rem]';
          case 'left_top':
            return '-tw-top-8 -tw-left-12';
          case 'right_top':
            return '-tw-top-8 -tw-right-12';
          case 'left_center':
            return 'tw-top-1/2 -tw-left-12 tw-transform -tw-translate-y-1/2';
          case 'right_center':
            return 'tw-top-1/2 -tw-right-12 tw-transform -tw-translate-y-1/2';
          case 'center':
            return 'tw-top-1/3 tw-left-1/2 tw-transform -tw-translate-x-1/2 -tw-translate-y-1/2';
          case 'mobile_bottom_center':
            return 'tw-transform tw-bottom-2 tw-left-1/2 -tw-translate-x-1/2';
          default:
            return '-tw-bottom-8 -tw-right-12';
        }
      } else if (this.companyKey === 'pendlehillproperties') {
        switch (position) {
          case 'left_bottom':
            return '-tw-bottom-8 -tw-left-[5rem] tw-rotate-[155deg]'; 
          case 'right_bottom':
            return 'tw-bottom-2 -tw-right-[0rem] tw-rotate-[5deg] '; 
          case 'left_top':
            return 'tw-top-2 -tw-left-12'; 
          case 'right_top':
            return '-tw-top-8 -tw-right-12'; 
          case 'left_center':
            return 'tw-top-1/2 -tw-left-12 tw-transform -tw-translate-y-1/2'; 
          case 'right_center':
            return 'tw-top-1/2 -tw-right-1 tw-transform -tw-translate-y-2/3'; 
          case 'center':
            return 'tw-top-1/3 tw-left-1/2 tw-transform -tw-translate-x-1/2 -tw-translate-y-1/2';  
          case 'mobile_bottom_center':
            return 'tw-transform tw-bottom-2 tw-left-1/2 -tw-translate-x-1/2'; 
          default:
            return '-tw-bottom-8 -tw-right-12'; 
        }
      } else {
        switch (position) {
          case 'left_bottom':
            return '-tw-bottom-12 -tw-left-8';
          case 'right_bottom':
            return '-tw-bottom-12 -tw-right-8';
          case 'left_top':
            return '-tw-top-12 -tw-left-8';
          case 'right_top':
            return '-tw-top-12 -tw-right-8';
          case 'left_center':
            return 'tw-top-1/2 -tw-left-8 tw-transform -tw-translate-y-1/2';
          case 'right_center':
            return 'tw-top-1/2 -tw-right-8 tw-transform -tw-translate-y-1/2';
          case 'center':
            return 'tw-top-1/2 tw-left-1/2 tw-transform -tw-translate-x-1/2 -tw-translate-y-1/2';
          case 'mobile_bottom_center':
            return 'tw-transform tw-bottom-0 tw-left-1/2 -tw-translate-x-1/2';
          default:
            return '-tw-bottom-12 -tw-right-8';
        }
      }
    },
    getPositionStyle(): string {
      // @ts-ignore - props are correctly defined above
      const color = this.blockColor && this.blockColor !== '' ? this.blockColor : 'primary';
      return `color: var(--c-${color}); opacity: ${this.blockOpacity};`;
    },
  },
});
</script>

<style scoped>
.block {
  font-size: 32em !important;
  font-weight: 700 !important;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: 1;
  margin: 0;
  padding: 0;
  position: absolute;
  pointer-events: none;
}
</style>
